import React from "react";
import { Button, DialogActions, useTheme } from "@mui/material";
import { isEqual } from "lodash";
import { useTranslation } from "react-i18next";
import SubmitOptions from "./SubmitOptions/SubmitOptions";
import { EmployeeDTO, EmployeeRef } from "../../../../../models/employees";
import { EXPENSE_REPORT_STATUS } from "../../../../../utils/constants/constants";
import { ExpenseReportStatusType } from "../AddEditExpenseReport";

interface Props {
  effect: "add" | "edit";
  resetAndCloseDialog: () => void;
  employee?: EmployeeRef | null;
  handleSign: (signatureContents: string) => void;
  parentIsLoading: boolean;
  expenseReportStatusId: string | undefined;
  handleChangeStatus: (newStatus: ExpenseReportStatusType) => void;
  disabledButtons: {
    draft: boolean;
    cancel: boolean;
    submit: boolean;
  };
}

const EmployeeActions = ({
  effect,
  resetAndCloseDialog,
  employee,
  handleSign,
  parentIsLoading,
  expenseReportStatusId,
  disabledButtons,
  handleChangeStatus,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_expense_report";

  const theme = useTheme();

  return (
    <DialogActions
      style={{
        justifyContent: "space-between",
        padding: "20px",
      }}
    >
      <Button
        variant={"outlined"}
        style={{
          color: theme.palette.actions.cancel,
          borderColor: theme.palette.actions.cancel,
        }}
        onClick={resetAndCloseDialog}
      >
        {`${t(`buttons.go_back`)}`}
      </Button>

      <>
        {effect === "add" && (
          <>
            <Button
              variant={"contained"}
              color={"info"}
              onClick={() => {
                handleChangeStatus(EXPENSE_REPORT_STATUS.draft);
              }}
              disabled={disabledButtons.draft}
            >
              {`${t(`${tRP}.form.buttons.save_as_draft`)}`}
            </Button>

            <SubmitOptions
              employee={employee as EmployeeDTO}
              disabled={disabledButtons.submit}
              handleSubmit={handleSign}
              translationRootPath={"components.add_edit_expense_report.submit_options"}
              parentIsLoading={parentIsLoading}
            />
          </>
        )}

        {effect === "edit" &&
          (isEqual(expenseReportStatusId, EXPENSE_REPORT_STATUS.draft.id) ||
            isEqual(expenseReportStatusId, EXPENSE_REPORT_STATUS.returned_to_employee.id)) && (
            <>
              <Button
                variant={"contained"}
                color={"info"}
                onClick={() => {
                  handleChangeStatus(EXPENSE_REPORT_STATUS.draft);
                }}
                disabled={disabledButtons.draft}
              >
                {`${t(`buttons.save`)}(${t(`${tRP}.form.buttons.draft`)})`}
              </Button>

              <SubmitOptions
                employee={employee as EmployeeDTO}
                disabled={disabledButtons.submit}
                handleSubmit={handleSign}
                translationRootPath={"components.add_edit_expense_report.submit_options"}
                parentIsLoading={parentIsLoading}
              />
              <Button
                variant={"contained"}
                color={"warning"}
                onClick={() => {
                  handleChangeStatus(EXPENSE_REPORT_STATUS.cancelled);
                }}
                disabled={disabledButtons.cancel}
              >
                {`${t(`${tRP}.form.buttons.cancel`)}`}
              </Button>
            </>
          )}
      </>
    </DialogActions>
  );
};

export default EmployeeActions;
